import { render, staticRenderFns } from "./OrderForm.vue?vue&type=template&id=4641044a&scoped=true&"
import script from "./OrderForm.vue?vue&type=script&lang=js&"
export * from "./OrderForm.vue?vue&type=script&lang=js&"
import style0 from "./OrderForm.vue?vue&type=style&index=0&id=4641044a&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4641044a",
  null
  
)

export default component.exports